import React, { useEffect, useState } from 'react';
import useTranslations from '@hooks/useTranslations';
import { IModalSessionChange } from './index';
import Button from '@components/Button';
import Spinner from '@components/Spinner';
import { getOfferCarTitle } from '@components/OfferListItem/utils/getOfferCartitle';
import { useExteriorPreviewImage } from '@utils/Image.utils';
import {useDispatch} from "react-redux";
import UiDuck from "../../../redux/commonDucks/ui.duck";

export const ModalSessionChangeTemplate = ({
    className,
    continueWithNewConfiguration,
    changeWithPreviousConfiguration,
    newConfiguration,
    previousConfiguration,
}: IModalSessionChange) => {
    const { t } = useTranslations();

    const dispatch = useDispatch();

    const [isLoading, setIsLoading] = useState(false);

    const newConfigurationImage = useExteriorPreviewImage(newConfiguration?.fullProductConfiguration?.images, 'list');
    const previousConfigurationImage = useExteriorPreviewImage(
        previousConfiguration?.fullProductConfiguration?.images,
        'list'
    );

    return (
        <div className={className}>
            <p className="description">{t('modal.sessionChange.description')}</p>
            <div className="buttons">
                {isLoading && <Spinner size={36} border={2} color="black" />}
                {!isLoading && (
                    <div className="section">
                        <span className="name">{getOfferCarTitle(newConfiguration.fullProductConfiguration)}</span>
                        <img className="image" src={newConfigurationImage} />
                        <Button
                            onClick={() => {
                                setIsLoading(true);
                                continueWithNewConfiguration();
                            }}
                            primary
                            fitContentWidth
                            centerMode
                        >
                            {t('modal.sessionChange.button.new')}
                        </Button>
                    </div>
                )}
                {!isLoading && (
                    <div className="section">
                        <span className="name">{getOfferCarTitle(previousConfiguration.fullProductConfiguration)}</span>
                        <img className="image" src={previousConfigurationImage} />
                        <Button
                            onClick={() => {
                                setIsLoading(true);
                                changeWithPreviousConfiguration();
                                dispatch(UiDuck.closeModal());
                                setIsLoading(false);
                            }}
                            secondary
                            fitContentWidth
                            centerMode
                        >
                            {t('modal.sessionChange.button.previous')}
                        </Button>
                    </div>
                )}
            </div>
        </div>
    );
};
